import { useCallback, useState } from 'react';
import { useActiveSection } from './hooks/useActiveSection';
import { useSectionTracking } from './hooks/useSectionTracking';
import { useScrollProgress } from './hooks/useScrollProgress';
import { useScrollReveal } from './hooks/useScrollReveal';
import { handleSectionClick } from './utils/scroll';
import {
  AmbientBackground,
  CursorGlow,
  ScrollProgress,
  Nav,
  MobileMenu,
  Hero,
  Marquee,
  Projects,
  Experience,
  About,
  Skills,
  Contact,
  Footer,
} from './components';

export default function App() {
  const activeId = useActiveSection();
  const { progress, scrolled } = useScrollProgress();
  const [menuOpen, setMenuOpen] = useState(false);
  useSectionTracking();
  useScrollReveal();

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <div className="relative min-h-screen bg-void text-muted">
      <AmbientBackground />
      <CursorGlow />
      <ScrollProgress progress={progress} />

      <a
        href="#main-content"
        onClick={(e) => handleSectionClick(e, '#main-content')}
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[70] focus:px-4 focus:py-2 focus:bg-accent focus:text-void focus:text-sm focus:font-medium focus:rounded-full"
      >
        Skip to content
      </a>

      <Nav
        scrolled={scrolled}
        activeId={activeId}
        menuOpen={menuOpen}
        onMenuOpen={() => setMenuOpen(true)}
      />
      <MobileMenu open={menuOpen} onClose={closeMenu} activeId={activeId} />

      <div className="relative z-10">
        <Hero />
        <Marquee />
        <main id="main-content">
          <Experience />
          <Projects />
          <About />
          <Skills />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}
